/* eslint-disable eqeqeq */
import tu from "@/utils/toolutil";
/*
  *@Author: 王伟东
  *@Date: 2021-07-19 11:55:46
  *@Description: 获取传递进来的字段当中是链式的写法处理
  *@params: value代表当前在data当中绑定的的字段名(带有小数点)
*/
function GETCONCRETEFIELD(value) {
  // var len = value.split(".").length;
  // if (len === 1) {
  //   return "this['" + value.split(".")[0] + "']";
  // } else if (len === 2) {
  //   return "this['" + value.split(".")[0] + "']" + "['" + value.split(".")[1] + "']";
  // } else if (len === 3) {
  //   return "this['" + value.split(".")[0] + "']" + "['" + value.split(".")[1] + "']" + "['" + value.split(".")[2] + "']";
  // }
  return "this." + value;
}
/**
 *宋建国：2020/3/20 10:30
 *描述：混入对象意义：
 * 1、每个实例组件随机定义一个唯一标识，
 * 2、在组件销毁时处理Matt消息分发取消操作
 *版本：1.0
 */
export const CaseOnly = {
  data() {
    return {
      _XYJ_CaseOnly_Id: tu.createRandom(),
      _XYJ_CallBack_Function: null
    };
  },
  mounted() {
    // if ( this.$route.params._XYJ_CallBack_Function){
    //    this._XYJ_CallBack_Function = this.$route.params._XYJ_CallBack_Function;
    // } else if (this.$route.query._XYJ_CallBack_Function) {
    //   if ( this.$route.params._XYJ_CallBack_Function){
    //      this._XYJ_CallBack_Function = this.$route.params._XYJ_CallBack_Function;
    //   }
    // }
  },
  methods: {
    /*
     *@Author: 王伟东
     *@Date: 2021-07-19 11:55:46
     *@Description: 验证手机号
     *@params: value代表当前在data当中绑定的的字段名 如 @input="VALIDATEPHONE('fieldname')"
    */
    VALIDATEPHONE(value) {
      if (!value) {
        this.$toast("VALIDATEPHONE方法需要你传进来当前在data当中绑定的字段名");
        return;
      }
      var ele = window.event;
      var val = ele.target.value;
      var strField = GETCONCRETEFIELD(value);
      if (val === "") {
        eval(strField + ' = ""');
        return;
      }
      if (val.charAt(0) != 1) {
        eval(strField + ' = ""');
        return;
      }
      if (val.charAt(1) == 0 || val.charAt(1) == 1 || val.charAt(1) == 2 || isNaN(val.charAt(1))) {
        eval(strField + ' = "1"');
        return;
      }
      if (val.indexOf(".") != -1) {
        eval(strField + " = val.split('.')[0]");
        return;
      }
      if (isNaN(val)) {
        eval(strField + " = parseInt(val)");
        return;
      }
      if (val.length > 11) {
        eval(strField + " = val.slice(0, 11)");
        return;
      }
    },
    /*
     *@Author: 王伟东
     *@Date: 2021-07-19 14:28:45
     *@Description: 验证金额
     *@params: value代表当前在data当中绑定的的字段名 d代表保留的小数位数 如 @input="VALIDATEMONEY('fieldname')"
    */
    VALIDATEMONEY(value, c, d) {
      var n = d || 2;// 小数位数
      var n2 = isNaN(c) ? "+" : c; // 小数位左侧位数
      if (!value) {
        this.$toast("VALIDATEMONEY方法需要你传进来当前在data当中绑定的的字段名");
        return;
      }
      var strField = GETCONCRETEFIELD(value);
      var val = String(eval(strField));
      eval(strField + " = this.jquery.trim(val)");
      if (isNaN(val.charAt(0))) {
        eval(strField + ' = ""');
        return;
      }
      if (isNaN(val)) {
        eval(strField + " = String(parseFloat(val))");
        return;
      }
      if (String(val).indexOf("e") != -1 || String(val).indexOf("E") != -1) {
        val = val.replace(/e|E/g, "");
        eval(strField + " = String(parseFloat(val))");
      }
      if (n2 != "+") {
        if (n2 == 0) {
          eval(strField + " = '' ");
          return;
        }
        if (val.indexOf(".") != -1) {
          if (val.split(".")[0].length > n2) {
            eval(strField + ' = val.split(".")[0].slice(0, n2) + "." + val.split(".")[1]');
          }
        } else {
          if (val.length > n2) {
            eval(strField + " = val.slice(0, n2) ");
            return;
          }
        }
      }
      if (val.length >= 2) {
        if (val.charAt(0) == "0" && val.charAt(1) >= 0) {
          eval(strField + ' = "0"');
          return;
        } else if (val.indexOf(".") != -1) {
          if (val.split(".")[1].length > n) {
            eval(strField + ' = val.split(".")[0] + "." + val.split(".")[1].slice(0, n)');
            return;
          }
        }
      }
    },
    /*
     *@Author: 王伟东
     *@Date: 2021-07-19 15:07:20
     *@Description: 验证整数
     *@params: value代表当前在data当中绑定的的字段名 d代表保留的位数 如 @input="VALIDATEINTEGER('fieldname')"
    */
    VALIDATEINTEGER(value, d, isNoZero) {
      var n = d || "+"; // 不传代表无限
      if (!value) {
        this.$toast("VALIDATEINTEGER方法需要你传进来当前在data当中绑定的字段名");
        return;
      }
      var strField = GETCONCRETEFIELD(value);
      var val = String(eval(strField));
      eval(strField + " = this.jquery.trim(val)");
      if (isNoZero) {
        if (Number(val) === 0) {
          eval(strField + ' = ""');
          return;
        }
      } else {
        if (val === "") {
          eval(strField + ' = ""');
          return;
        }
      }
      if (isNaN(val.charAt(0))) {
        eval(strField + ' = ""');
        return;
      }
      if (n == "+") {
        eval(strField + " = String(parseInt(val))");
      } else {
        eval(strField + " = String(parseInt(val.slice(0, n)))");
      }
    },
    /*
     *@Author: 验证数值范围
     *@Date: 2021-07-19 15:07:20
     *@Description: 验证整数
     *@params: value代表当前在data当中绑定的的字段名 a代表开始范围 b代表结束范围 如 @blur="VALIDATEINTEGER('money'，1,3)" 表示输入位数长度在1位-3位之间的数字
    */
    VALIDATE_NUMBER_LIMIT(value, a, b) {
      if (!value) {
        this.$toast("VALIDATE_NUMBER_LIMIT方法需要你传进来当前在data当中绑定的字段名");
        return;
      }
      var strField = GETCONCRETEFIELD(value);
      var val = String(eval(strField));
      if (val === "") {
        eval(strField + ' = ""');
        return;
      }
      if (isNaN(val)) {
        eval(strField + ' = ""');
        return;
      }
      if (val.length < a || val.length > b) {
        eval(strField + ' = ""');
        return;
      }
    },
    /*
     *@Author: 验证数值大小
     *@Date: 2021-07-19 15:07:20
     *@Description: 验证整数
     *@params: value代表当前在data当中绑定的的字段名 a代表开始范围 b代表结束范围 如 @blur="VALIDATEINTEGER('money'，1,300)" 表示只能输入1-300之间的数字
    */
    VALIDATE_NUMBER_SIZE(value, a, b) {
      if (!value) {
        this.$toast("VALIDATE_NUMBER_SIZE方法需要你传进来当前在data当中绑定的字段名");
        return;
      }
      var strField = GETCONCRETEFIELD(value);
      var val = String(eval(strField));
      if (val === "") {
        eval(strField + ' = ""');
        return;
      }
      if (isNaN(val)) {
        eval(strField + ' = ""');
        return;
      }
      if (Number(val) < a || Number(val) > b) {
        eval(strField + ' = ""');
        return;
      }
    },
    /*
     *@Author: zhangjunna
     *@Date: 2021-11-24 16:01:51
     *@Description: 用于弹框的取消确定回调
    */
    _xyjCallback(data){}
  },
  beforeDestroy() {
    this.$mqtt.clearSubScribe(this.$data._XYJ_CaseOnly_Id);
    // if(this.$tu.isFunction(this._XYJ_CallBack_Function)){
    //   this._XYJ_CallBack_Function();
    // }
  },
  activated(){
    if(this.isWorkflow){
      // 如果表格有审批，更新状态
      setTimeout(() => {
        if(this.getSelected().length > 0){
          this.updateDataFromId(this.getSelected()[0].id)
          if(xyjVue.$tu.getapplyStateChange(this.getSelected()[0].applyState)){
            this.getSelected()[0]['isShow'] = true;
          }else{
            this.getSelected()[0]['isShow'] = false;
          }
        }
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/CaseOnlyMixin.js